import React from "react";
import BuilderTable from "../../Layouts/BuilderTable";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";

const BuilderUsersTable = ({ data, allRoles, onEdit, onDelete, onAssign }) => {
  const getUserRoles = (roles) => {
    if (!roles?.length) return "";
    return roles
      .map((rId) => allRoles.find((r) => r.id === rId)?.name)
      .filter(Boolean)
      .join(", ");
  };

  // Standard Columns
  const columns = [
    { key: "first_name", header: "First Name" },
    { key: "last_name", header: "Last Name" },
    { key: "email", header: "Email" }
  ];

  const customColumns = [
    {
      header: "Role",
      render: (user) => <div>{getUserRoles(user.roles)}</div>
    },
    {
      header: "Assigned",
      render: (user) => {
        const hasData = user.orgs?.length || user.apps?.length;
        return (
          <div className={`assigned-cell clickable`} onClick={() => onAssign(user)} role="button" tabIndex={0}>
            {hasData ? (
              <>
                {user.orgs && <span>{user.orgs.length} orgs</span>}
                {user.orgs && user.apps && <span className="separator">•</span>}
                {user.apps && <span>{user.apps.length} apps</span>}
              </>
            ) : (
              <span className="empty">Assign apps / orgs</span>
            )}
          </div>
        );
      }
    },
    {
      header: "Actions",
      render: (user) => (
        <>
          <ButtonActionIcon type="edit" onClick={() => onEdit(user)} />
          <ButtonActionIcon type="delete" onClick={() => onDelete(user.id, user.first_name, user.last_name)} />
        </>
      )
    }
  ];

  return (
    <BuilderTable
      columns={columns}
      data={data}
      customColumns={customColumns}
      columnStyles={{
        Actions: { display: "flex", gap: "4px" },
        Assigned: { cursor: "pointer", minWidth: "120px" }
      }}
      noDataMessage="No Users Found"
    />
  );
};

export default BuilderUsersTable;
